<div id="top-bar" class="cpm-header" [ngClass]="themeClass">
  <div class="cpm-header-name p-l-20" >
    Central Plant Manager
  </div>
  @if (!loginUserTypeData.isPublic && multiRegionEnabled) {
    <div class="cpm-header-org p-r-16">
      @if (!isFac) {
        <app-select-dropdown [(ngModel)]="selectedRegionId" ngDefaultControl class="select-dropdown header-org notranslate" [placeholderLabel]="'Select Region'" [data]="regionList"
          [displayKey]="'name'"
          [search]="false" [valueKey]="'regionId'" (ngModelChange)="regionIdChanged($event)">
        </app-select-dropdown>
      }
    </div>
  }
  @if (!loginUserTypeData.isPublic) {
  <div class="cpm-header-org">

    <!--Organization Selection Dropdown-->
    <app-site-selection-dropdown class="notranslate" [id]="'orgListDropdown'" [config]="orgSelectionDropdownConfig"
      [items]="organizationList" [itemsLoading]="orgLoading" (selectionChange)="orgSelectionChanged()"
      [(value)]="selectedOrg.id" [shortcutKey]="OPEN_SITE_SELECTION_SHORTCUT_KEYS.ORGANIZATION">
    </app-site-selection-dropdown>
  </div>
  }

  @if (!loginUserTypeData.isPublic && showHide) {
    <div class="cpm-header-plant" [ngClass]="{'pointer-events-none': !showPlantDropDown} ">
      @if (selectedOrg.id) {
        <mat-form-field [style.display]="editing? 'none': ''"
          class="dashboardSelectorFormField">
          <mat-select (openedChange)="clearPlantSearchField($event)" [(ngModel)]="selectedPlant" (selectionChange)="onPlantChange($event.value)"
            [placeholder]="!showPlantDropDown ? 'Loading...':'Select a Plant'" disableOptionCentering panelClass="dashboardSelector" #plantSelector
            class="plant-dropdown" matTooltip="{{selectedPlant?.chillerPlantName}}">
            <input #plantSearchField id="plantSearchField" autocomplete="off" class="plantSearchField" placeholder="" matInput type="text" (keyup)="onKey($event, $event.target.value)"  (keydown)="$event.stopPropagation()" panelWidth="208">
            @if (selectedPlant?.chillerPlantName) {
              <mat-select-trigger>
                {{selectedPlant.chillerPlantName}}
              </mat-select-trigger>
            }
            @if (plantListClone.length > 0) {
              @for (plant of plantListClone; track plant) {
                <mat-option [value]="plant" matTooltip="{{plant.chillerPlantName}}"
                  matTooltipPosition='above' class="hide-checkbox chiller-plant-option">
                  {{plant.chillerPlantName}}
                </mat-option>
              }
            }
            @if (plantListClone.length == 0 && (!isFac || (isFac && isBuilderUser))) {
              <mat-option class="hide-checkbox">
                <button style="padding-left: 2px;" mat-button color="primary" class="add-plant-btn"
                (click)="editAddPlant('add')">ADD PLANT</button>
              </mat-option>
            }
            @if (plantListClone.length > 0 && (!isFac || (isFac && isBuilderUser))) {
              <button mat-button color="primary" class="add-plant-btn"
              (click)="plantSelector.close(); editAddPlant('add')">ADD PLANT</button>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (editing) {
        <mat-form-field appearance="outline" class="dashboardInputFormField" style="margin-top: -15px; width: 181px;"
          >
          <input matInput #NameInput autocomplete="off" [value]="selectedPlant.chillerPlantName">
          <div matSuffix>
            <i class="fas fa-times appIcon" (click)="discardNameEdit($event)"></i>
            <i class="fas fa-check appIcon" (click)="saveNameEdit(NameInput.value)"></i>
          </div>
        </mat-form-field>
      }
    </div>
  }

  @if (buildingName?.length > 0 && !loginUserTypeData.isPublic) {
    <div  class="buildingName notranslate" [ngClass]="{'p-r-16': selectedTabIndex != 1}" [matTooltip]="" matTooltipPosition="left" matTooltipClass="custom-tooltip" showTooltipOnOverflow>
      {{buildingName}}
    </div>
  }

  @if (loginUserTypeData.isPublic) {
    <div class="sharedPlantName">
      {{plantName}}
    </div>
  }

  @if ((selectedTabIndex == 1 && buildingName?.length > 0 ) && (!isFac || (isFac && isBuilderUser))) {
    <div class="edit-plant-icon" title="Edit Plant" (click)="editAddPlant('edit')">
      <i class="fa fa-pencil" aria-hidden="true"></i>
    </div>
  }

  @if ((selectedTabIndex == 1 && buildingName?.length > 0) && (!isFac || (isFac && isBuilderUser))) {
    <div class="delete-plant-icon p-r-16" title="Delete Plant" (click)="deletePlant()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </div>
  }

  <div class="toogle-div">
    <input type="checkbox" (change)="changeTheme()" class="checkbox" id="chk" [checked]="toggleChecked" [value]="toggleTheme"/>
    <label class="label" for="chk">
      <i class="fas fa-sun"></i>
      <i class="fas fa-moon"></i>
      <div class="ball"></div>
    </label>
  </div>

  @if (selectedTabIndex == 0 && showTabsButtons) {
    <div  class="statusSelector">
      @if (selectedTabIndex == 0 && showTabsButtons) {
        <mat-button-toggle-group [(ngModel)]="selectedPointIcon" #statusIcongroup="matButtonToggleGroup"
          >
          <mat-button-toggle title="Status View" [ngClass]="{'statusButton': statusIcongroup.value === 'statusView'} "
            (click)="statusView('statusView', true)" value="statusView">
            <img class="statusIcon" src='{{"../../../../assets/images/" + pointStatusIcon.statusView + ".svg" }}'>
          </mat-button-toggle>
          <mat-button-toggle title="Minimum View" [ngClass]="{'statusButton': statusIcongroup.value === 'valueView'} "
            (click)="statusView('valueView', true)" value="valueView">
            <img class="statusIcon" src='{{"../../../../assets/images/" + pointStatusIcon.valueView + ".svg" }}'>
          </mat-button-toggle>
          <mat-button-toggle title="Expanded View" [ngClass]="{'statusButton': statusIcongroup.value === 'listView'} "
            (click)="statusView('listView', true)" value="listView">
            <img class="statusIcon" src='{{"../../../../assets/images/" + pointStatusIcon.listView + ".svg" }}'>
          </mat-button-toggle>
          <mat-button-toggle title="Expanded with Trends"
            [ngClass]="{'statusButton': statusIcongroup.value === 'trendView'} " (click)="statusView('trendView', true)"
            value="trendView">
            <img class="statusIcon" src='{{"../../../../assets/images/" + pointStatusIcon.trendView + ".svg" }}'>
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
  }
  @if (buildingName?.length > 0) {
    <div class="plant-builder-view">
      <mat-tab-group mat-align-tabs="end" (selectedTabChange)="viewChanged($event)" [(selectedIndex)]="selectedTabIndex" >
        <mat-tab label="My Plant"></mat-tab>
        @if (!isFac || (isFac && isBuilderUser)) {
          <mat-tab  label="Plant Builder" [disabled] = 'disableMatTab'></mat-tab>
        }
      </mat-tab-group>
    </div>
  }
</div>